export default function ServiceNotAvailable({
  serviceName
}: {
  serviceName?: string;
}) {
  return (
    <div className="h-full flex flex-col justify-center items-center gap-6 p-4">
      <div className="text-6xl">🚫</div>
      <h2 className="text-xl font-semibold text-center">
        {serviceName
          ? `${serviceName} is not available`
          : "Feature not available"}
      </h2>
      <p className="text-center text-gray-500 max-w-md">
        This feature is currently disabled or you do not have permission to
        access it. Please contact your property manager if you believe this is
        an error.
      </p>
    </div>
  );
}
